import { useEffect, useState } from "react";

const links = [
  { label: "功能介绍", href: "#features" },
  { label: "快速体验", href: "#demo" },
  { label: "使用步骤", href: "#steps" },
  { label: "适用场景", href: "#scenes" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/80 bg-background-50/95 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between md:h-[72px]">
        <a
          href="#top"
          className="group flex items-center gap-2.5 whitespace-nowrap"
          aria-label="吃瓜网页 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-700 text-background-50">
            <i className="ri-scissors-2-line text-lg" aria-hidden="true" />
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              light ? "text-background-50" : "text-foreground-900"
            }`}
          >
            吃瓜网页
          </span>
        </a>

        <div
          className={`hidden items-center gap-1 md:flex ${
            light ? "text-background-50/85" : "text-foreground-700"
          }`}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`rounded-full px-3.5 py-2 text-sm transition-colors ${
                light
                  ? "hover:bg-background-50/10 hover:text-background-50"
                  : "hover:bg-background-100 hover:text-foreground-900"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#demo"
            className={`rounded-full px-5 py-2.5 text-sm whitespace-nowrap transition-all ${
              light
                ? "bg-background-50 text-primary-700 hover:bg-background-100"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            开始体验
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
            light ? "text-background-50" : "text-foreground-800"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <div className="container-x flex flex-col gap-1 py-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#demo"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-lg bg-primary-500 px-3 py-2.5 text-center text-sm text-background-50"
            >
              开始体验
            </a>
          </div>
        </div>
      )}
    </header>
  );
}